import { render, staticRenderFns } from "./zgyw.vue?vue&type=template&id=57cc6a6e"
import script from "./zgyw.vue?vue&type=script&lang=js"
export * from "./zgyw.vue?vue&type=script&lang=js"
import style0 from "./zgyw.vue?vue&type=style&index=0&id=57cc6a6e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports